import React, {useState,useEffect} from "react";
import './App.css';
import PC from './PC';
import Phone from './Phone';

function App() {
  //const [PC_, setPC_] = useState(false); 
  
  const [PC_, setPC_] = useState(); 

  useEffect(()=>{
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
      setPC_(false); 
    }else{
      setPC_(true);
    }
  },[])  


  return (
    <div className="App">
      {PC_?(
        <>
        <PC/>
        </>
      ):(
        <>
        <Phone/>
        </>
      )}

    </div>
  );
}

export default App;
